<template>
    <div>
        <section class="feature-section section-odd">
            <div class="container">
                <h2><i class="p1 fa fa-exchange-alt"></i> Any Data Source, Any Destination and Format</h2>
                <p class="text-center feature-lead feature-lead-bordered">
                  Skippr is a <strong>universal data format and integration</strong> tool, you have complete freedom to migrate data between any system, format and truly multi-cloud.
                </p>
              <p>
                CSV, Json, XML, Avro, Parquet, Arrow... think of Skippr as your effortless bridge beyond data integration.
              </p>

              <div class="row">
                <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                  <img src="images/homepage/section1.svg" />
                </div>
              </div>

            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'RealTime',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
